import React, {useContext} from 'react';
import {Link} from 'gatsby';
import Img from 'gatsby-image';
import {currencyFormat, dotFormat} from '../../helpers/formatPrice';
import {getUnit} from '../../helpers/getUnit';
import {StoreContext} from '../../store';
import useSiteMeta from '../../query/useSiteMeta';
import useDefaultPicture from '../../query/useDefaultPicture';
import {useStock} from '../../hooks/useStock';

import styles from './styles.module.css';

const Product = ({product, shadow = false}) => {
  const {noStock, siteUrl} = useSiteMeta();
  const {
    id,
    title,
    price,
    image,
    quantity,
    unit,
    onlyShop,
    onlyShopOrLyon,
    withDays,
    withWeekEnd,
    reduceShipping,
    tva,
    variations,
    variationName,
  } = product.frontmatter;

  const defaultPicture = useDefaultPicture();
  const store = useContext(StoreContext);

  const {customOptions, _stock, minPrice, _price} = useStock({
    store,
    id,
    price,
    variations,
  });
  const meta = {};
  if (onlyShop === true) {
    meta.onlyShop = true;
  }
  if (onlyShopOrLyon === true) {
    meta.onlyShopOrLyon = true;
  }
  if (withDays) {
    meta.withDays = true;
  }
  if (withWeekEnd) {
    meta.withWeekEnd = true;
  }
  if (reduceShipping) {
    meta.reduceShipping = true;
  }
  const {slug} = product.fields;
  return (
    <div className={`${styles.product} ${shadow ? styles.shadow : ''}`}>
      <Link to={slug}>
        {image ? (
          <Img
            alt={title}
            className={styles.product_img}
            fluid={image.childImageSharp.fluid}
          />
        ) : (
          <Img
            alt={title}
            className={styles.product_img}
            fluid={defaultPicture.childImageSharp.fluid}
          />
        )}
      </Link>
      <h2>
        <Link to={slug}>{title}</Link>
      </h2>
      <div className={styles.variantes}>
        {customOptions &&
          variations.map(n => {
            if (n.label && n.label.length > 10) return null;
            return (
              <span key={n.label} className={styles.variant}>
                {n.label}
              </span>
            );
          })}
      </div>
      <span style={{textAlign: 'right'}}>
        {_stock === 0 && customOptions === null ? (
          <span className={styles.nostock}>
            <strong>{noStock}</strong>
          </span>
        ) : null}
        {_stock !== undefined &&
        _stock < 3 &&
        _stock > 0 &&
        customOptions === null ? (
          <span className={styles.limitstock}>
            <strong>
              {_stock}{' '}
              {_stock === 1 ? 'encore disponible' : 'encore disponibles'}
            </strong>
          </span>
        ) : null}
      </span>
      <div className={styles.infos_product}>
        {quantity && !customOptions && (
          <strong className={styles.product__unity}>
            {quantity} {getUnit(unit, quantity)}
          </strong>
        )}
        <strong className={styles.price}>
          {customOptions ? (
            <>
              <span>à partir de</span> {currencyFormat(minPrice)}
            </>
          ) : (
            currencyFormat(_price)
          )}
        </strong>
      </div>
      <span className={styles.infoComp}>
        {withDays === true ? (
          <span className={styles.onlyShop}>
            Uniquement en retrait dans la semaine
          </span>
        ) : null}
        {withWeekEnd === true ? (
          <span className={styles.onlyShop}>
            Uniquement en retrait le samedi ou dimanche
          </span>
        ) : null}
        {onlyShop === true && !withDays && !withWeekEnd ? (
          <span className={styles.onlyShop}>
            Uniquement en retrait, pas de livraison
          </span>
        ) : null}
        {onlyShopOrLyon === true && !onlyShop && !withDays && !withWeekEnd ? (
          <span className={styles.onlyShopOrLyon}>
            Produit uniquement en retrait ou en livraison sur Lyon.
          </span>
        ) : null}
      </span>
      {withDays === true || customOptions ? (
        <Link
          className={styles.linkTo}
          title={`En savoir plus sur ${title}`}
          to={slug}
        >
          En savoir plus
        </Link>
      ) : (
        <div
          className={`${styles.cart_actions}  ${
            withDays === true || customOptions ? styles.hide_btn_add_cart : ''
          }`}
        >
          <button
            className="snipcart-add-item"
            data-item-id={id}
            data-item-price={dotFormat(_price)}
            data-item-url={slug}
            data-item-has-taxes-included="true"
            data-item-description={`${
              onlyShop === true
                ? 'Produit uniquement en retrait, pas de livraison.|'
                : ''
            } ${
              onlyShopOrLyon === true && !onlyShop
                ? 'Produit uniquement en retrait.|'
                : ''
            } ${product.excerpt}`}
            data-item-image={
              image
                ? `${siteUrl}${image.childImageSharp.fluid.src}`
                : `${siteUrl}${defaultPicture.childImageSharp.fluid.src}`
            }
            data-item-name={title}
            data-item-quantity="1"
            data-item-taxes={tva || 'TVA 5.5'}
            disabled={_stock === 0 ? true : false}
            data-item-metadata={JSON.stringify(meta)}
            data-item-custom1-name={
              customOptions ? (variationName ? variationName : 'Options') : null
            }
            data-item-custom1-options={
              customOptions ? customOptions.slice(0, -1) : null
            }
          >
            Ajouter au panier
          </button>
        </div>
      )}
    </div>
  );
};

export default Product;
